import { FC, PropsWithChildren, createContext, useContext } from 'react';

export enum ContentType {
  Conditional, // Content that has conditions attached to it
  Default, // Content that is shown when no conditions are met
}

type ConditionalContentContextState = {
  type: ContentType;
};

export const defaultState: ConditionalContentContextState = {
  type: ContentType.Default,
};

const ConditionalContentContext = createContext(defaultState);

type ConditionalContentContextProviderProps = {
  type: ContentType;
};

export const ConditionalContentContextProvider: FC<
  PropsWithChildren<ConditionalContentContextProviderProps>
> = ({ type, children }) => {
  return (
    <ConditionalContentContext.Provider value={{ type }}>
      {children}
    </ConditionalContentContext.Provider>
  );
};

export const useConditionalContentContext = () => useContext(ConditionalContentContext);
